// Component Styles
const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center'
  },
})

export default styles
